export default __webpack_public_path__ + "static/media/logo.e3aa2c21.svg";